import { createContext } from 'react';
import BaseGraph from '../model';
import DynamicPositionedGraph from '../model/dynamicGraph';
import PositionedGraph from '../model/positionedGraph';
import { PedigreeCondition } from '../types';

// -----------------------------------------------------------------------------
export interface PedigreeContextType {
  baseGraph: BaseGraph | null;
  setBaseGraph: (graph: BaseGraph) => void;
  positionedGraph: PositionedGraph | null;
  setPositionedGraph: (graph: PositionedGraph) => void;
  dynamicGraph: DynamicPositionedGraph | null;
  setDynamicGraph: (graph: DynamicPositionedGraph) => void;
  initializeGraphs: () => Promise<void>;
  refreshFlag: boolean;
  setRefreshFlag: (value: boolean) => void;
  selectedNodeId: number | null;
  setSelectedNodeId: (nodeId: number | null) => void;
  extraData: {
    conditions: PedigreeCondition[];
  };
  setExtraData: (data: { conditions: PedigreeCondition[] }) => void;
  mode: 'view' | 'edit';
  setMode: (mode: 'view' | 'edit') => void;
  relationshipSelectionMode: {
    isActive: boolean;
    firstNodeId: number | null;
  };
  setRelationshipSelectionMode: (mode: {
    isActive: boolean;
    firstNodeId: number | null;
  }) => void;
  canUndo: boolean;
  canRedo: boolean;
  undo: () => void;
  redo: () => void;
  saveStateForUndo: () => void;
}

// -----------------------------------------------------------------------------
export const PedigreeContext = createContext<PedigreeContextType | undefined>(
  undefined
);
